import {
  GetChatMessageAttachmentsData,
  ChatMessagesData,
  MessageTemplate,
} from 'core_main/api/messages/types';
import {
  IncludedUser,
  Included,
  IncludedTemplate,
  IncludedArticle,
} from 'core_main/pubnub/types';
import { addUserToStore, getUserFromStore } from 'core_main/store';
import {
  MessageCallbackResponse,
  MessageAttachmentCallbackResponse,
} from './types';
import { createArticleCallbackResponse } from '../get_articles/helpers';

export const createAttachmentCallbackResponse = (
  attachment: GetChatMessageAttachmentsData,
): MessageAttachmentCallbackResponse => {
  const { related } = attachment.links;
  const { id } = attachment;
  const { contentLength, contentType, name } = attachment.attributes;

  return { url: related, attachmentId: id, contentLength, contentType, name };
};
export const createMessageCallbackResponse = (
  messageData: ChatMessagesData,
  attachments?: GetChatMessageAttachmentsData[],
  includedData?: Included[],
  source: 'historical' | 'pubnub' = 'pubnub', // @deprecated: do not use
): MessageCallbackResponse => {
  const includedUser = includedData?.find(
    (included) => included.type === 'user',
  ) as IncludedUser;
  let userAttributes = includedUser?.attributes;

  if (userAttributes) {
    const userId = includedUser?.id;
    addUserToStore(userId, userAttributes);
  } else {
    userAttributes = getUserFromStore(
      messageData?.relationships?.sentBy?.data?.id,
    );
  }

  const includedTemplate = includedData?.find(
    (included) => included.type === 'template',
  ) as IncludedTemplate;

  const includedArticles = (
    includedData?.filter(
      (included) => included.type === 'article',
    ) as IncludedArticle[]
  )?.map(createArticleCallbackResponse);

  const { id: messageId, attributes, relationships } = messageData;

  let attachmentCallbackResponses;

  if (attachments?.length) {
    attachmentCallbackResponses = attachments.map((attachment) =>
      createAttachmentCallbackResponse(attachment),
    );
  }

  const {
    appGenerated,
    auto,
    body,
    bodyOverride,
    createdAt,
    direction,
    directionType,
    titleOverride,
    meta,
  } = attributes;
  const conversationId = relationships.session.data.id;
  const sentByType = relationships.sentBy?.data?.type;
  const sentById = relationships.sentBy?.data?.id;
  const displayName = userAttributes?.displayName;
  const avatarUrl = userAttributes?.avatarUrl;
  const isInAssistantMode = Boolean(meta?.assistant);

  const template: MessageTemplate = includedTemplate && {
    ...includedTemplate?.attributes,
    id: includedTemplate?.id,
  };

  return {
    appGenerated,
    messageId,
    body,
    createdAt,
    direction,
    directionType,
    conversationId,
    attachments: attachmentCallbackResponses,
    isInAssistantMode,
    meta: {
      template,
      articles: includedArticles,
    },
    notificationOverrides: {
      bodyOverride,
      titleOverride,
    },
    sentBy: {
      type: auto ? 'user' : sentByType,
      id: sentById,
      displayName,
      avatarUrl,
    },
    source,
  };
};
